import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
const weekday = require("dayjs/plugin/weekday");

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(weekday);
dayjs.tz.setDefault("Asia/Taipei");
dayjs.weekStart = 0;

export const formatTime = (time) => {
  return dayjs(time).format("YYYY-MM-DD");
};

export const getWeek = (weekStart, weekEnd) => {
  // 獲得當前時間
  let current = dayjs();

  // 設定一天開始的時間為中午12:00
  let dayStart = "12:00";

  // 如果當前時間在中午12:00之前，認為還是前一天
  if (current.format("HH:mm") < dayStart) {
    current = current.subtract(1, "day");
  }

  const start = current.weekday(weekStart).format("YYYY-MM-DD");
  const end = current.add(1, "week").weekday(weekEnd).format("YYYY-MM-DD");

  return { start, end };
};
export const getMonth = (month, day) => {
  let current = dayjs();

  if (
    current.hour() < 12 ||
    (current.hour() === 12 && current.minute() === 0 && current.second() === 0)
  ) {
    current = current.subtract(1, "day");
  }

  const start = current
    .subtract(month, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const end = current
    .subtract(month, "month")
    .endOf("month")
    .add(day, "day")
    .format("YYYY-MM-DD");
  return { start, end };
};
export const getToday = ({ add = 0 } = {}) => {
  let current = dayjs();

  // 設定一天開始的時間為中午12:00
  let dayStart = "12:00";

  if (current.format("HH:mm") < dayStart) {
    current = current.subtract(1, "day");
  }
  const today = current.add(add, "day").toDate();
  return today;
};
export const getTomorrow = () => {
  const tomorrow = dayjs().add(1, "day").toDate();
  return tomorrow;
};

export const getYesterday = ({ add = 0 } = {}) => {
  let current = dayjs();

  // 設定一天開始的時間為中午12:00
  let dayStart = "12:00";

  // 如果當前時間在中午12:00之前，認為還是前一天
  if (current.format("HH:mm") < dayStart) {
    current = current.subtract(1, "day");
  }

  const yesterday = current.add(add - 1, "day").format("YYYY-MM-DD");
  return yesterday;
};

export const getThreeDays = () => {
  const threeDay = dayjs().add(-3, "day").toDate();
  return threeDay;
};

export const getSevenDays = () => {
  const sevenDays = dayjs().add(-7, "day").toDate();
  return sevenDays;
};
export const getThirtyDays = () => {
  const thirtyDays = dayjs().add(-30, "day").toDate();
  return thirtyDays;
};

export const getCustomDays = (day) => {
  const customDays = dayjs().add(-day, "day").toDate();
  return customDays;
};
